import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/***加载全局css***/
import './style/normalize.css';
import './style/iconfont/iconfont.css'
import './style/iconfont/iconfont.js'
/***加载Antd***/
import 'ant-design-vue/dist/antd.css';
import Antd from 'ant-design-vue';

Vue.config.productionTip = false

Vue.use(Antd);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
